import { render, staticRenderFns } from "./mall-add.vue?vue&type=template&id=4237b336&scoped=true"
import script from "./mall-add.vue?vue&type=script&lang=js"
export * from "./mall-add.vue?vue&type=script&lang=js"
import style0 from "./mall-add.vue?vue&type=style&index=0&id=4237b336&prod&scoped=true&lang=css"
import style1 from "./mall-add.vue?vue&type=style&index=1&id=4237b336&prod&lang=scss&scoped=true"
import style2 from "./mall-add.vue?vue&type=style&index=2&id=4237b336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4237b336",
  null
  
)

export default component.exports